export default __webpack_public_path__ + "static/media/img-0434-hungary-full-face.ed06548f.png";